export default "__VITE_ASSET__YeLNDCz3__"